import apiClient from '../axios.js'

export const systemCommerceStorefrontApi = {
  getTemplateCategories: () =>
    apiClient.get('/system/commerce/storefront-template-categories'),

  putTemplateCategories: (categories) =>
    apiClient.put('/system/commerce/storefront-template-categories', { categories }),
}
